import React, { Component } from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import { Table, Button, Modal, Tooltip } from 'antd';
import isEqual from 'lodash/isEqual';
import isEmpty from 'lodash/isEmpty';

import './index.scss';

import * as pageActions from '../../../../../data/redux/page_details/actions';
import * as botMessageActions from '../../../../../data/redux/botmessage_details/actions';

import { APP_PAGES, PERMISSIONS } from '../../../../../data/config/constants';
import { uniqueId, showMessage, log } from '../../../../../data/config/utils';
import { IMG_ERROR } from '../../../../../data/assets/img';

import ErrorBoundary from '../../../../../components/errorboundary';
import PageHeaderLoader from '../../../../../components/pageheader/loaders';
import CardRowTableLoader from '../../../components/loaders/cardrowtable';
import CustomHeader from '../../../../../components/customheader';
import TableCellAction from '../../../components/tablecellaction';
import BotMessageForm from '../../../components/botmessageform';
import ShowMessage from '../../../../../components/showmessage';

class BotMessages extends Component {
    constructor(props) {
        super(props);
        this.bot_message_table_columns = this.getBotMessageColumns();
        this.state = {
            search_text: "",
            filtered_bot_messages: props.botmessage_details.bot_messages,
            current_bot_message: null,
            modal_data: {
                title: "",
                show_edit_message: false,
                show_create_message: false,
            },
        };
    }

    componentWillMount() {
        const { actions } = this.props;
        actions.pageChanged(APP_PAGES.BOT_MESSAGES, APP_PAGES.BOT_BUILDER);
    }

    componentDidMount() {
        const { actions, botmessage_details } = this.props;
        if (isEmpty(botmessage_details.bot_messages)) {
            actions.getBotMessages();
        }
        if (isEmpty(botmessage_details.bot_messages_schema)) {
            actions.getBotMessagesSchema();
        }
    }

    componentWillReceiveProps(nextProps) {
        const { botmessage_details } = this.props;
        const { search_text } = this.state;
        if (!isEqual(nextProps.botmessage_details.bot_messages, botmessage_details.bot_messages)) {
            const table_data = [...nextProps.botmessage_details.bot_messages];
            if (search_text.trim().length !== 0) {
                this.setState({
                    filtered_bot_messages: this.filterBotMessagesBySearchText(search_text, table_data)
                });
            } else {
                this.setState({
                    filtered_bot_messages: table_data
                });
            }
        }
    }

    getBotMessageColumns = () => {
        const columns = [
            {
                title: "Type",
                key: "type",
                dataIndex: "type",
                sorter: (t1, t2) => { if (t1.type > t2.type) return 1; else return -1; },
            },
            {
                title: "Message Identifier",
                key: "identifier",
                dataIndex: "identifier"
            },
            {
                title: "Tag",
                key: "tags",
                dataIndex: "tags",
                render: (tags) => {
                    return (
                        tags.map((item, index) => { return (<Tooltip key={index} overlayClassName="ori-font-xs" placement="top" title={item.tooltip}><Button size="small" type="primary" className="ori-font-xxs ori-height-auto ori-r-mrgn-3 ori-tb-mrgn-3" ghost>{item.tag}</Button></Tooltip>); })
                    );
                }
            },
            {
                title: "Action",
                key: "action",
                dataIndex: "action",
                render: (text, record) => {
                    return (
                        <TableCellAction show_edit show_delete delete_popconfirm_title="Are you sure delete this bot message?" handleEditClick={() => this.handleEditMessage(record)} handleDeleteClick={() => this.handleDeleteBotMessage(record)} />
                    );
                }
            }
        ];
        return columns;
    };

    filterBotMessagesBySearchText = (text, bot_messages) => {
        return bot_messages.filter((message) => {
            return ((message.type && message.type !== undefined && message.type.toLowerCase().indexOf(text.toLowerCase()) !== -1) || (message.identifier && message.identifier !== undefined && message.identifier.toLocaleString().toLowerCase().indexOf(text.toLowerCase()) !== -1));
        });
    };

    handleMessageSearch = (event) => {
        const search_text = event.target.value;
        const { botmessage_details } = this.props;
        this.setState({ search_text });
        if (search_text.trim().length !== 0) {
            this.setState({
                filtered_bot_messages: this.filterBotMessagesBySearchText(search_text, botmessage_details.bot_messages)
            });
        } else {
            this.setState({
                filtered_bot_messages: botmessage_details.bot_messages
            });
        }
    };

    closeModal = () => {
        this.setState({
            current_bot_message: null,
            modal_data: {
                title: "",
                show_edit_message: false,
                show_create_message: false,
            }
        });
        this.props.actions.resetPopupBotMessage();
    };

    handleAddNewMessage = () => {
        const { isActionPermitted } = this.props;
        if (isActionPermitted(PERMISSIONS.ACTIONS.BOT_MESSAGE, PERMISSIONS.ACTION_TYPES.CREATE)) {
            this.setState({
                current_bot_message: null,
                modal_data: {
                    title: "Create Bot Mesaage",
                    show_edit_message: false,
                    show_create_message: true,
                }
            });
        } else {
            showMessage('warning', 'you have not permission to create new bot message.');
        }
    };

    handleEditMessage = (message) => {
        const { isActionPermitted, actions } = this.props;
        if (isActionPermitted(PERMISSIONS.ACTIONS.BOT_MESSAGE, PERMISSIONS.ACTION_TYPES.UPDATE)) {
            let payload = { mID: message.id };
            actions.getBotMessageDetails(payload, () => {
                this.setState({
                    current_bot_message: message,
                    modal_data: {
                        title: "Edit Bot Mesaage",
                        show_edit_message: true,
                        show_create_message: false,
                    }
                });
            });
        } else {
            showMessage('warning', 'you have not permission to update bot message.');
        }
    };

    handleDeleteBotMessage = (bot_message) => {
        const { isActionPermitted, actions } = this.props;
        if (isActionPermitted(PERMISSIONS.ACTIONS.BOT_MESSAGE, PERMISSIONS.ACTION_TYPES.DELETE)) {
            const payload = { id: bot_message.id };
            actions.deleteBotMessage(payload);
        } else {
            showMessage('warning', 'you have not permission to delete bot message.');
        }
    };

    handleUpdateBotMessage = ({ formData }) => {
        const payload = {
            [formData.type]: { ...formData[formData.type] },
            type: formData.type,
            mID: this.state.current_bot_message.id
        };
        log('update payload', payload);
        this.props.actions.updateBotMessage(payload, this.closeModal);
    };

    handleCreateBotMessage = ({ formData }) => {
        const payload = {
            [formData.type]: { ...formData[formData.type] },
            type: formData.type,
        };
        log('create payload', payload);
        this.props.actions.createBotMessage(payload, this.closeModal);
    };

    render() {
        const { page_details, botmessage_details, actions } = this.props;
        const { filtered_bot_messages, modal_data } = this.state;
        const mobile = page_details.device_data.screen_width < 768;

        if (botmessage_details.loaders.bot_messages_loading && !botmessage_details.loaders.bot_messages_loaded) {
            return (
                <div className="ori-full-parent-height oriBotMessagesContainer">
                    <PageHeaderLoader container_class="ori-lr-pad-10" bottom_bordered />
                    <div className="ori-pad-10">
                        <CardRowTableLoader />
                    </div>
                </div>
            );
        } else if (!botmessage_details.loaders.bot_messages_loading && botmessage_details.loaders.bot_messages_loaded) {
            return (
                <div className="ori-full-parent-height ori-lr-pad-10 oriBotMessagesContainer">
                    <CustomHeader title="bot messages" first_button_text="+ Add Message" first_button_type="primary" onClickFirstButton={this.handleAddNewMessage} search_placeholder="Search Messages" onChangeSearch={this.handleMessageSearch} bottom_bordered show_first_button show_search />
                    <div className="ori-tb-pad-10">
                        <Table className="ori-card-row-table" rowClassName="ori-bg-white ori-border-radius-4 ori-box-shadow-light" scroll={{ x: 600 }} size={mobile ? "small" : "middle"} rowKey={uniqueId} columns={this.bot_message_table_columns} dataSource={filtered_bot_messages} />
                    </div>
                    <Modal className={classNames("ori-modal-primary ori-modal-lg oriBotMessageModal")} title={modal_data.title} footer={null} maskClosable={false} visible={modal_data.show_edit_message || modal_data.show_create_message} onCancel={this.closeModal}>
                        {
                            modal_data.show_edit_message &&
                            <ErrorBoundary onErrorCallback={this.closeModal}>
                                <BotMessageForm screen_height={page_details.device_data.screen_height} screen_width={page_details.device_data.screen_width} button_ok_text="update" loading={botmessage_details.loaders.bot_message_updating} schema={botmessage_details.bot_messages_schema} ui_schema={botmessage_details.bot_messages_ui_schema} form_data={botmessage_details.message_form_data} context_variables_data={botmessage_details.context_variables_data} updateMessageFormData={actions.updateMessageFormData} handleOkClick={this.handleUpdateBotMessage} handleCancelClick={this.closeModal} />
                            </ErrorBoundary>
                        }
                        {
                            modal_data.show_create_message &&
                            <ErrorBoundary onErrorCallback={this.closeModal}>
                                <BotMessageForm screen_height={page_details.device_data.screen_height} screen_width={page_details.device_data.screen_width} button_ok_text="create" loading={botmessage_details.loaders.bot_message_updating} schema={botmessage_details.bot_messages_schema} ui_schema={botmessage_details.bot_messages_ui_schema} form_data={botmessage_details.message_form_data} context_variables_data={botmessage_details.context_variables_data} updateMessageFormData={actions.updateMessageFormData} handleOkClick={this.handleCreateBotMessage} handleCancelClick={this.closeModal} />
                            </ErrorBoundary>
                        }
                    </Modal>
                </div>
            );
        } else if (!botmessage_details.loaders.bot_messages_loading && !botmessage_details.loaders.bot_messages_loaded) {
            return (
                <ShowMessage img_src={IMG_ERROR} title="Error" message="unable to load bot message details. please check your intenet connection and reload the page." height={150} width={150} />
            );
        } else {
            return null;
        }
    }
}

function mapStateToProps(state) {
    return {
        page_details: state.page_details,
        botmessage_details: state.botmessage_details
    };
}

function mapDispatchToProps(dispatch) {
    return {
        actions: bindActionCreators(Object.assign({}, pageActions, botMessageActions), dispatch)
    };
}

BotMessages.propTypes = {
    actions: PropTypes.object,
    page_details: PropTypes.object,
    botmessage_details: PropTypes.object,
    history: PropTypes.object,
    match: PropTypes.object,
    isActionPermitted: PropTypes.func,
};

export default connect(mapStateToProps, mapDispatchToProps, null, { withRef: true })(BotMessages);



// WEBPACK FOOTER //
// ./src/app/pagecontainer/modules/botbuilder/botmessages/index.js